import qs from 'qs';

import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async searchMedicineByName({ name }) {
    const query = qs.stringify({ term: name });
    const response = await axiosPrivate.get(`/medicines/search?${query}`);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getMedicineByFilter({ name, form, strength }) {
    const query = qs.stringify({ name, form, strength });
    const response = await axiosPrivate.get(`/medicines/filter?${query}`);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },
};
